var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLgSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 30",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 18,
    height: 19,
    rx: 1,
    fill: "#A8FFF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 18,
    height: 10,
    rx: 1,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.304 4.38c0-.21.185-.38.413-.38h14.87c.228 0 .413.17.413.38v15.2c0 .21-.185.38-.413.38h-14.87c-.228 0-.413-.17-.413-.38V4.38zm.826.38V19.2h14.044V4.76H25.13z",
    fill: "#14454C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.413 6.28c.228 0 .413.17.413.38v15.58H37.11c.228 0 .413.17.413.38s-.185.38-.413.38H21.413c-.228 0-.413-.17-.413-.38V6.66c0-.21.185-.38.413-.38z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.804 7.8c.228 0 .413.17.413.38s-.184.38-.413.38h-6.608c-.229 0-.413-.17-.413-.38s.184-.38.413-.38h6.608zM37.109 11.6c.228 0 .413.17.413.38s-.185.38-.413.38h-9.913c-.229 0-.413-.17-.413-.38s.184-.38.413-.38h9.913zM37.109 15.4c.228 0 .413.17.413.38s-.185.38-.413.38h-9.913c-.229 0-.413-.17-.413-.38s.184-.38.413-.38h9.913z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13h17v11H23V13z",
    fill: "#14454C",
    fillOpacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 6l.99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99L50.5 6zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566L59 17zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99L9.5 21zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566L2 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-lg-summary-f11d85c8adc35773dd4430e275f03fee.svg";
export { SvgAiLgSummary as ReactComponent };